import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { sanlamVeryLightgray, sanlamDarkGrayishBlue } from 'Material-UI/colors';
import { Grid } from '@material-ui/core';

import ChevronCardButtonList from 'components/ChevronCardButtonList';
import { SmallSectionHeader } from 'components/Typography';
import { StyledShortBody } from 'containers/ASIDashboard/services/styles';
import messages from 'containers/ASIDashboard/services/messages';
import { translate } from 'helpers/intl';
import PAGES from 'routes/pages';
import { getLocations } from 'store/global/actions';
import { CASABLANCA, FILTERS } from 'components/MapFilter/constants';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

export interface ServicesBlocPropsType {
  intl: IntlShape;
  mdGrid?: any;
  smGrid?: any;
}
const ServicesBloc = (props: ServicesBlocPropsType) => {
  const items = [
    {
      title: (
        <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
          {translate({ ...messages.partnerClinic }, props)}
        </StyledShortBody>
      ),
      icon: 'clinique',
      path: PAGES.SERVICES,
      category: EVENT_CATEGORIES.ASI_ACCUEIL,
      label: 'Mes Services _Localiser les cliniques partenaires',
      payload: getLocations({
        filterWith: FILTERS.clinics,
        research: '',
        latitude: CASABLANCA.lat,
        longitude: CASABLANCA.lon,
      }),
    },
  ];
  return (
    <React.Fragment>
      <Grid container>
        <Grid xs={12} item>
          <SmallSectionHeader>
            {translate({ ...messages.myServices }, props)}
          </SmallSectionHeader>
        </Grid>
        <ChevronCardButtonList
          borderColor={sanlamVeryLightgray}
          items={items}
          spacing={2}
          deleteHoverBorder={true}
          mdGrid={props.mdGrid}
          smGrid={props.smGrid}
        />
      </Grid>
    </React.Fragment>
  );
};

export default injectIntl(ServicesBloc);
